import type { Major, CareerPath } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { getMajorUnderEmploymentRating } from '@backrs_ui/grow-ui/src/pages/Majors/majors.utils';

export const useAgentContext = (major: Major, highRelevanceCareerPaths: CareerPath[]) => {
  const { rating } = getMajorUnderEmploymentRating(major);

  useRegisterAgentContext({
    kind: 'section',
    title: 'Career Outcomes',
    description:
      'Underemployment rate, associated career paths, and sample job roles for graduates with this major',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Underemployment Rate',
    display:
      'Card with toggleable underemployment vs success rate shown as a large percentage, with a rating badge',
    detail: appStrings.modules.majors.careerOutcomes
      .underEmploymentInfo(major.underEmploymentRationale)
      .join('\n'),
    data: {
      rating,
      underemploymentRate: major.underEmployment,
      successRate: 1 - major.underEmployment,
    },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Career Paths & Sample Roles',
    display: 'Pill chips for high-relevance career paths and badge chips for sample job titles',
    data: {
      careerPaths: highRelevanceCareerPaths.map((cp) => cp.name),
      sampleJobs: major.sampleJobs,
    },
  });
};
